
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./advanced-1-server.json") })
        }
      }, "path---advanced-1-server");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---advanced-1-server!./.cache/json/advanced-1-server.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---advanced-1-server!./.cache/json/advanced-1-server.json
// module chunks = 154